(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["AppleCollectionSlider2026"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var swiper = new Swiper('.strapp-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 0, 
    speed: 800, 
    grabCursor: true, 
    
    // Critical "Anti-Jump" and image loading fixes
    observer: true,
    observeParents: true,
    resizeObserver: true,
    touchEventsTarget: 'wrapper',
    passiveListeners: false,
    threshold: 10,
    resistance: true,
    resistanceRatio: 0,
    
    keyboard: {
      enabled: true, 
    },
    autoplay: false, 
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true, 
    },
    navigation: {
      nextEl: '.strapp-next',
      prevEl: '.strapp-prev',
    },
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["AppleFabricCollectionSlider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var swiper = new Swiper('.strapp-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 0, 
    speed: 800, 
    grabCursor: true, 
    
    // Critical "Anti-Jump" and image loading fixes
    observer: true,
    observeParents: true,
    resizeObserver: true,
    touchEventsTarget: 'wrapper',
    passiveListeners: false,
    threshold: 10,
    resistance: true,
    resistanceRatio: 0,
    
    keyboard: {
      enabled: true, 
    },
    autoplay: false, 
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true, 
    },
    navigation: {
      nextEl: '.strapp-next',
      prevEl: '.strapp-prev',
    },
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["CollectionSlider2026"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var swiper = new Swiper('.strapp-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 0, 
    speed: 800, 
    grabCursor: true, 
    
    // Critical "Anti-Jump" and image loading fixes
    observer: true,
    observeParents: true,
    resizeObserver: true,
    touchEventsTarget: 'wrapper',
    passiveListeners: false,
    threshold: 10,
    resistance: true,
    resistanceRatio: 0,
    
    keyboard: {
      enabled: true, 
    },
    autoplay: false, 
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true, 
    },
    navigation: {
      nextEl: '.strapp-next',
      prevEl: '.strapp-prev',
    },
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Ultra-Collection-Slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof Swiper !== 'undefined') {
      new Swiper('.strapp-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 10,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.strapp-next',
          prevEl: '.strapp-prev',
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-product-info"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const accordionHeaders = document.querySelectorAll('.accordion__header');

    accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const item = this.closest('.accordion__item');
        const content = item.querySelector('.accordion__content');
        const isCurrentlyOpen = item.classList.contains('open');

        // Optional: Close all others when a new one is opened (Uncomment below to enable)
        // document.querySelectorAll('.accordion__item.open').forEach(openItem => {
        //   if (openItem !== item) {
        //     openItem.classList.remove('open');
        //     openItem.querySelector('.accordion__content').style.display = 'none';
        //     openItem.setAttribute('aria-expanded', 'false');
        //   }
        // });

        if (isCurrentlyOpen) {
          // Close the current one
          item.classList.remove('open');
          content.style.display = 'none';
          this.setAttribute('aria-expanded', 'false');
        } else {
          // Open the current one
          item.classList.add('open');
          content.style.display = 'block';
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-gallery-meta"]) return;
  try {
    
/* Swiper JS */
var swiperScript = document.createElement('script');
swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js';
swiperScript.onload = function() {
  new Swiper('.collection-gallery-swiper', {
    slidesPerView: 2,           // Mobile default
    spaceBetween: 2,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 4,       // Desktop
      }
    },
  });
};
document.head.appendChild(swiperScript);

/* Swiper CSS */
var swiperCSS = document.createElement('link');
swiperCSS.rel = 'stylesheet';
swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css';
document.head.appendChild(swiperCSS);

/* GLightbox JS */
var lightboxScript = document.createElement('script');
lightboxScript.src = 'https://cdn.jsdelivr.net/npm/glightbox/dist/js/glightbox.min.js';
lightboxScript.onload = function() {
  const lightbox = GLightbox({ selector: '.glightbox' });
};
document.head.appendChild(lightboxScript);

/* GLightbox CSS */
var lightboxCSS = document.createElement('link');
lightboxCSS.rel = 'stylesheet';
lightboxCSS.href = 'https://cdn.jsdelivr.net/npm/glightbox/dist/css/glightbox.min.css';
document.head.appendChild(lightboxCSS);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider-apple-fabric"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.strapp-swiper', {
  slidesPerView: 'auto', // Allow automatic adjustment, change to a number if needed
  spaceBetween: 10, // Space between slides
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.strapp-next',
    prevEl: '.strapp-prev',
  },
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider-apple-leather"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.strapp-swiper', {
  slidesPerView: 'auto', // Allow automatic adjustment, change to a number if needed
  spaceBetween: 10, // Space between slides
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.strapp-next',
    prevEl: '.strapp-prev',
  },
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider-apple-silicone"] && !Shopify.designMode) return;
  try {
    
 var swiper = new Swiper('.strapp-swiper', {
  slidesPerView: 'auto', // Allow automatic adjustment, change to a number if needed
  spaceBetween: 10, // Space between slides
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.strapp-next',
    prevEl: '.strapp-prev',
  },
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider-apple"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('.strapp-swiper', {
  slidesPerView: 'auto', 
  spaceBetween: 10,
  // Autoplay removed to disable auto-sliding
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.strapp-next',
    prevEl: '.strapp-prev',
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider-fkm"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('.strapp-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 10,
  autoplay: false,
  // The autoplay object has been removed
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.strapp-next',
    prevEl: '.strapp-prev',
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider-leather"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.strapp-swiper', {
  slidesPerView: 'auto', // Allow automatic adjustment, change to a number if needed
  spaceBetween: 10, // Space between slides
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.strapp-next',
    prevEl: '.strapp-prev',
  },
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
